<template>
  <v-dialog v-model="show" persistent scrollable max-width="650px">
    <v-card>
      <v-toolbar flat short color="primary" dark>
        <v-app-bar-nav-icon>
          <v-icon>fad fa-phone</v-icon>
        </v-app-bar-nav-icon>
        <v-toolbar-title>How'd the call go?</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-subheader class="pb-0">Callback Required</v-subheader>
              <v-radio-group class="mt-0" hide-details dense v-model="phoneCallOutcome">
                <v-radio
                  v-for="outcome in DiallerCallbackOutcomes"
                  :key="outcome.id"
                  :label="outcome.name"
                  :value="outcome"
                ></v-radio>
                <v-radio
                  v-for="outcome in DiallerManualCallbackOutcomes"
                  :key="outcome.id"
                  :label="outcome.name"
                  :value="outcome"
                ></v-radio>
              </v-radio-group>
              <v-menu
                ref="dateMenu"
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                v-if="manualCallback"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="scheduledCallbackDateFormatted"
                    label="Callback scheduled for"
                    prepend-icon="fad fa-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="scheduledCallbackDate"
                  no-title
                  @input="dateMenu = false"
                  :min="minDate"
                ></v-date-picker>
              </v-menu>
              <v-menu
                ref="timeMenu"
                v-model="timeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="scheduledCallbackTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                v-if="manualCallback"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="scheduledCallbackTime"
                    label="at"
                    prepend-icon="fad fa-clock"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="timeMenu"
                  v-model="scheduledCallbackTime"
                  full-width
                  no-title
                  :min="minTime"
                  format="24hr"
                  @click:minute="$refs.timeMenu.save(scheduledCallbackTime)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-subheader class="pb-0">No Callback Required</v-subheader>
              <v-radio-group class="mt-0" dense v-model="phoneCallOutcome">
                <v-radio
                  v-for="outcome in DiallerNoCallbackOutcomes"
                  :key="outcome.id"
                  :label="outcome.name"
                  :value="outcome"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click="closeDialog(false)">Cancel</v-btn>
        <v-btn color="success" @click="closeDialog(true)" :disabled="!outcomeSelected">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import dialler from '../../../api/dialler';

export default {
  name: 'CloseCallDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dateMenu: false,
    timeMenu: false,
    phoneCallOutcome: null,
    minDate: moment().format('YYYY-MM-DD'),
    scheduledCallbackDate: moment().format('YYYY-MM-DD'),
    scheduledCallbackTime: moment().format('HH:mm')
  }),
  computed: {
    ...mapGetters([
      'ActiveCall',
      'DiallerCallbackOutcomes',
      'DiallerManualCallbackOutcomes',
      'DiallerNoCallbackOutcomes'
    ]),
    minTime() {
      return moment(this.scheduledCallbackDate).isSame(moment(), 'day') ? moment().format('HH:ss') : null;
    },
    manualCallback() {
      return this.phoneCallOutcome !== null && this.phoneCallOutcome.manual_callback;
    },
    scheduledCallbackDateFormatted() {
      return moment(this.scheduledCallbackDate).format('DD/MM/YYYY');
    },
    outcomeSelected() {
      return this.phoneCallOutcome !== null;
    },
    scheduledCallbackDateTime() {
      return moment(`${this.scheduledCallbackDate} ${this.scheduledCallbackTime}`).unix();
    }
  },
  methods: {
    ...mapActions(['clearActiveCall', 'updateActiveCall']),
    closeDialog(endCall = false) {
      if (endCall) {
        this.updateActiveCall({
          phone_call_outcome_id: this.phoneCallOutcome.id,
          end_time: moment().unix()
        }).then(() => this.clearActiveCall());
        if (this.phoneCallOutcome.manual_callback) {
          dialler.schedulePhoneCall(this.ActiveCall.id, this.scheduledCallbackDateTime);
        }
      }
      this.$emit('update:show', false);
    }
  }
};
</script>
